<template>
  <div  >
    <img v-if="props.isMini" src="https://static.ppkao.com/ppmg/img/appqrcode.webp"/>
    <div v-else class="box">
    <main class="box">
      <header class="header">
        <div class="wrap">
          <h1 title="题目标题">{{ word }}</h1>
        </div>
        <LazyTheme v-if="!props.isMini" class="theme-box" size="small"/>
      </header>
      <LazyChatSideBar :record="records"/>
      <LazyChatBox v-if="showBox"  @sendRecord="handleRecord" />
      <LazyChatMain v-else/>
    </main>
    <LazyChatBubbleBackground/>
  </div>
  </div>
</template>
<script setup>
const props = defineProps({
  isMini: {
    type: Boolean,
    default: false
  }
})
if (!props.isMini) {
  useHead({
    link: [
      {
        rel: 'stylesheet',
        href: 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.css',
        crossorigin: 'anonymous'
      }
    ],
    script: [
      {
        src: 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.js',
        defer: true,
        crossorigin: 'anonymous'
      },
      {
        src: 'https://cdn.jsdelivr.net/npm/katex@0.16.11/dist/contrib/auto-render.js',
        defer: true,
        crossorigin: 'anonymous'
      },
      {
        src: 'https://cdn.jsdelivr.net/npm/marked@13.0.2/marked.min.js',
        defer: true,
        crossorigin: 'anonymous'
      }
    ]
  });
}
provide('is-mini', props.isMini)
const route = useRoute();
const records = reactive([]);
const word = computed(() => props.isMini ? 'DeepSeek' : route.query.q ?? 'DeepSeek');
const showBox = computed(() => (route.query.q || route.query.date) && !props.isMini)
const handleRecord = (record) => {
  Object.assign(records, [...record]);
}
</script>
<style scoped lang="scss">
.mini {
  background: rgba(255,255,255,0.5);
  border: 2px solid var(--border-color);
  width: 390px;
  height: 680px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  /* 在这里添加你的样式 */
  .wrap h1 {
    width: 320px !important;
    color: var(--primary-color) !important;
    font-weight: bold;
  }
  .header {
    border-bottom: none !important;
  }
  :deep(.input-box) {
    width: 340px;
    height: 210px !important;
    .input-wrap {
      padding: 10px 10px 0 10px;
    }
    textarea::placeholder {
      font-size: 16px !important;
    }
    .tool-bar {
      button {
        width: 60px;
        height: 36px;
      }
    }
  }

  :deep(.main) {
    top: 50px;
    .search{
      padding-top: 60px;
      flex-wrap: wrap;
      justify-content: center;
      h2 {
        min-width: 300px;
        font-size: 30px;
        line-height: 40px;
        color: var(--title-color);
        span {
          font-size: 34px;
        }
      }
    }
    .search-box {
      top: 390px;
    }
  }

  :deep(.side-bar) {
    left: -232px;
  }
  :deep(.wrap-main) {
    height: calc(100% - 165px);
    overflow-x: hidden;
  }
  :deep(.wrap-box) {
    padding-top: 0;
    width: 340px;

    .text {
      font-size: 14px;
      line-height: 20px;
    }

    .lock-box {
      height: 74px !important;
    }

    .login-box {
      width: 220px;
      height: 92px;
    }

    .search-box {
      bottom: 20px;

      .input-box {
        height: 136px !important;

      }
      :deep(textarea::placeholder) {
        font-size: 16px !important;
      }
      :deep(.tool-bar) {
        button {
          font-size: 14px;
          width: 50px;
          height: 32px;
        }

        span {
          font-size: 14px;
        }
      }
    }

    .ai-text, .user-text {
      max-width: 280px !important;
      :deep(.rich-text) {
        p {
          max-width: 244px !important;
          overflow: auto;
        }
      }
    }
  }
}
.box {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  .header {
    width: 100%;
    background: var(--bg-color);
    border-bottom: 2px solid var( --border-color);
    position: relative;
    backdrop-filter: blur(20px);
    @include flex-y-center;
    z-index: 9;
    .wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 1920px;
      height: 48px;
      margin: 0 auto;

      h1 {
        width: 500px;
        font-size: 16px;
        color: var(--title-color);
        white-space: nowrap;       /* 不换行 */
        overflow: hidden;          /* 超出部分隐藏 */
        text-overflow: ellipsis;   /* 显示省略号 */
        text-align: center;
      }
    }
    .theme-box {
      position: absolute;
      right: 20%;
    }
  }

}


</style>
